/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Stat_Agents_LabelInputs */

const en_landing_stat_agents_label = /** @type {(inputs: Landing_Stat_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Agents`)
};

const de_landing_stat_agents_label = /** @type {(inputs: Landing_Stat_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Agenten`)
};

const fr_landing_stat_agents_label = /** @type {(inputs: Landing_Stat_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents IA`)
};

const es_landing_stat_agents_label = /** @type {(inputs: Landing_Stat_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes IA`)
};

const it_landing_stat_agents_label = /** @type {(inputs: Landing_Stat_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenti IA`)
};

const nl_landing_stat_agents_label = /** @type {(inputs: Landing_Stat_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-agenten`)
};

const pl_landing_stat_agents_label = /** @type {(inputs: Landing_Stat_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenci AI`)
};

const fi_landing_stat_agents_label = /** @type {(inputs: Landing_Stat_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-agentit`)
};

const da_landing_stat_agents_label = /** @type {(inputs: Landing_Stat_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-agenter`)
};

const sv_landing_stat_agents_label = /** @type {(inputs: Landing_Stat_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-agenter`)
};

/**
* | output |
* | --- |
* | "AI Agents" |
*
* @param {Landing_Stat_Agents_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_stat_agents_label = /** @type {((inputs?: Landing_Stat_Agents_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Stat_Agents_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_stat_agents_label(inputs)
	if (locale === "fr") return fr_landing_stat_agents_label(inputs)
	if (locale === "es") return es_landing_stat_agents_label(inputs)
	if (locale === "it") return it_landing_stat_agents_label(inputs)
	if (locale === "nl") return nl_landing_stat_agents_label(inputs)
	if (locale === "pl") return pl_landing_stat_agents_label(inputs)
	if (locale === "fi") return fi_landing_stat_agents_label(inputs)
	if (locale === "da") return da_landing_stat_agents_label(inputs)
	if (locale === "sv") return sv_landing_stat_agents_label(inputs)
	return en_landing_stat_agents_label(inputs)
});